import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    class: _vm.isDisabled && _vm.isCartInProgress ? "cursor--forbidden" : "",
    attrs: {
      title: _vm.isDisabled && _vm.isCartInProgress ? "Empty your cart to be allowed to edit this value" : ""
    }
  }, [_c(VSelect, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.gettingPricePostingUsaProPosted.items,
      "item-text": "applicationDateString",
      "return-object": "",
      "hide-no-data": "",
      "hide-details": "auto",
      placeholder: _vm.inputPlaceholder,
      disabled: _vm.isDisabled
    },
    on: {
      change: function change($event) {
        return _vm.selectPricePosting();
      }
    },
    model: {
      value: _vm.pricePostingSelected,
      callback: function callback($$v) {
        _vm.pricePostingSelected = $$v;
      },
      expression: "pricePostingSelected"
    }
  })], 1), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };